import * as ExceedingAmountActions from '../actions/exceeding-amount.actions';
import { ExceedingAmount } from '@dch/products-business-logic';

export const initialState: ExceedingAmount[] = [];

export function reducer(
  state: ExceedingAmount[] = initialState,
  action: ExceedingAmountActions.Actions,
) {
  switch (action.type) {
    case ExceedingAmountActions.GET_EXCEEDING_AMOUNT_SUCCESS:
      return [...state, action.payload.unbilledBalances[0]];
    default:
      return state;
  }
}
